export default "__VITE_ASSET__A0x_Hmt1__"